import React from 'react';
import Tooltip from 'layout/atoms/Tooltip';
import Grid from 'layout/molecules/Grid/Grid';
import parseImage from 'parsers/common/parseImage';
import styles from './Thumbnails.module.scss';
function Thumbnails({ items }) {
    return (React.createElement("div", { className: styles.row }, items.map(({ node }) => (React.createElement(Tooltip, { key: node.id, theme: "inverse", content: React.createElement(Grid, { gap: 6 },
            React.createElement("strong", null, node.name),
            node.description && React.createElement("div", null, node.description)), delay: 0 },
        React.createElement("div", { className: styles.thumbnail }, node.thumbnail ? (React.createElement("img", { src: parseImage(node.thumbnail) || '', alt: node.name })) : (React.createElement("span", { className: styles.name }, node.name))))))));
}
export default Thumbnails;
